<!--众筹专用订单详情页面-->
<template>
  <div class="crowdfunding-order-detail">
    <fixed-header :targetUrl="targetUrl" title="订单详情"></fixed-header>
    <div class="crowdfunding-order-detail__main scroll-touch">
      <div
          v-if="show_address"
          class="crowdfunding-order-detail__top"
          @click="gotoEdit"
      >
        <div>
          <i class="icon position"></i>
        </div>
        <div>
          <p>
            <span>{{ nowDetail.consignee }}</span>
            <span>{{ nowDetail.mobile }}</span>
          </p>
          <p>
            <span>{{ showAddress(nowDetail) }}</span>
            <i v-if="showEditAddr" class="icon left_arrow"></i>
          </p>
        </div>
      </div>
      <div class="crowdfunding-order-detail__content">
        <section class="crowdfunding-order-detail__content-status">
          {{ getOrderStatusTitle(nowDetail) }}
        </section>
        <section class="crowdfunding-order-detail__content-goods-wrap">
          <div
              v-for="(item, index) in nowDetail.goods_list"
              :key="index"
              class="crowdfunding-order-detail__content-goods"
          >
            <div
                class="crowdfunding-order-detail__content-goods-img"
                @click="gotoDetail(item.goods_id)"
            >
              <img :src="item.goods_image" alt=""/>
            </div>
            <div class="crowdfunding-order-detail__content-goods-sku">
              <p>
                <span>{{ item.goods_name }}</span>
                <span>{{ showPrice(nowDetail, item) }}</span>
              </p>
              <p>
                <span>{{ item.spec_key_name }}</span>
                <span>x{{ item.goods_num }}</span>
              </p>
              <goods-tags :tags="item.tags"></goods-tags>
              <p v-if="showRefundButton(item)">
                <span
                    :mg-stat-custom="'cont=申请售后&direct=cntp&label=btn'"
                    :mg-stat-lob="`order_id=${nowOrderId}`"
                    mg-stat-click
                    @click.stop="gotoRefund(item)"
                >申请售后</span
                >
              </p>
            </div>
          </div>
          <div v-if="isPreSell" class="crowdfunding-order-detail__presell-desc">
            <p v-if="showPreSellTip">
              预订不足{{
                nowDetail.pre_sell_info.min_amount
              }}件，定金自动全额退还；预售成功，定金不退
            </p>
            <div
                v-if="showPreSellBuy"
                class="crowdfunding-order-detail__presell-buy"
                @click="gotoPay"
            >
              <pre-buy-button
                  :price="nowDetail.order_amount"
                  :time="nowDetail.pre_sell_info.retainage_end"
              ></pre-buy-button>
            </div>
          </div>
          <div
              v-if="canRefund"
              class="crowdfunding-order-detail__content-button"
          >
            <span
                @click="
                isShowReasonPicker = true;
                hasAnyAction = true;
              "
            >退款</span
            >
          </div>
          <div
              v-if="showCancelRefund"
              class="crowdfunding-order-detail__content-cancel_button"
          >
            <span @click.stop="cancelRefundApply">取消退款</span>
          </div>
        </section>
        <section
            v-if="isPreSell"
            class="crowdfunding-order-detail__presell-item"
        >
          <p>
            <span>阶段一：{{ depositTitle }}</span>
            <span>￥{{ nowDetail.deposit_amount }}</span>
          </p>
          <p
              v-for="(item, index) in nowDetail.pre_sell_info.paid_money_ladder"
              :key="'paid' + index"
          >
            <span>前{{ item.amount }}名支付定金</span>
            <span>- ￥{{ getActualPrice(item.price) }}</span>
          </p>
          <p>
            <span>阶段二：{{ retainageTitle }}</span>
            <span>￥{{ nowDetail.retainage_amount }}</span>
          </p>
          <p
              v-for="(item, index) in nowDetail.pre_sell_info.price_ladder"
              :key="index"
          >
            <span>预售达{{ item.amount }}件 尾款优惠</span>
            <span> -￥{{ getActualPrice(item.price) }}</span>
          </p>
        </section>
        <section
            v-if="showUseTime"
            class="crowdfunding-order-detail__content-item"
        >
          <span>使用日期</span>
          <span>{{ getUseTime() }}</span>
        </section>
        <section
            v-if="!isPreSell"
            class="crowdfunding-order-detail__content-item"
        >
          <span>商品总价</span>
          <span
          >￥{{
              nowDetail.vipFeePrice
                  ? nowDetail.totalGoodsPrice
                  : nowDetail.goods_price
            }}</span
          >
        </section>
        <section class="crowdfunding-order-detail__content-item">
          <span>运费</span>
          <span>￥{{ nowDetail.shipping_price }}</span>
        </section>
        <section class="crowdfunding-order-detail__content-item">
          <span>{{ totalPriceTitle }}</span>
          <span>{{ totalPrice }}</span>
        </section>
      </div>
      <div class="crowdfunding-order-detail__bottom">
        <section>
          <div class="crowdfunding-order-detail__bottom-title">订单编号：</div>
          <div class="crowdfunding-order-detail__bottom-modal">
            {{ nowDetail.order_sn }}
          </div>
          <input id="orderInput" :value="nowDetail.order_sn" type="text"/>
          <button
              :mg-stat-custom="'cont=复制&direct=cntp&label=btn'"
              :mg-stat-lob="`order_id=${nowOrderId}`"
              class="copy_button"
              data-clipboard-target="#orderInput"
              mg-stat-click
          >
            复制
          </button>
        </section>
        <section>
          <div class="crowdfunding-order-detail__bottom-title">支付方式：</div>
          {{ showPayWay }}
        </section>
        <section>
          <div class="crowdfunding-order-detail__bottom-title">
            {{ showRefundStatus ? "申请时间：" : "下单时间：" }}
          </div>
          {{ showRefundStatus ? nowDetail.refund_time : nowDetail.add_time }}
        </section>
        <section v-if="showRefundStatus">
          <div class="crowdfunding-order-detail__bottom-title">退款状态：</div>
          {{ showRefundStatus }}
        </section>
        <section v-if="showRefundRemark">
          <div class="crowdfunding-order-detail__bottom-title">退款备注：</div>
          {{ showRefundRemark }}
        </section>
      </div>
    </div>
    <refund-picker
        :defaultKey="1"
        :isShow="isShowReasonPicker"
        :option="REFUND_OPTION"
        headerTitle="退款原因"
        @changeVisible="(val) => (isShowReasonPicker = val)"
        @confirm="submitReason"
    />
    <Pay
        :isShow="isShowPay"
        :oldOrderId="oldOrderId"
        :orderId="nowOrderId"
        :payCode="payCode"
        :price="nowDetail.order_amount"
        @changeVisible="(val) => (isShowPay = val)"
        @clickPay="uploadClose"
    ></Pay>
    <toUseButton v-if="useGotoLink" :useGotoLink="useGotoLink"></toUseButton>
  </div>
</template>

<script>
import FixedHeader from 'components/common/FixedHeader';
// import GoodsDemo from 'components/common/GoodsDemo';
import PreBuyButton from 'components/order/PreBuyButton';
import ToUseButton from 'components/order/ToUseButton';
import RefundPicker from 'components/refund/RefundPicker';
import GoodsTags from 'components/common/GoodsTags';
import Pay from 'components/common/Pay';
import ClipboardJS from 'clipboard';
import * as orderApi from 'apis/order';
import { REFUND_OPTION } from 'constants/refund';
import { getOrderStatusTitle, isPayDeposit, isWaitPay, showAddress } from 'utils/order';
import { dateFormater } from 'utils/date';
import {
  beforeRouteChange,
  getGoodsSizeNum,
  initCloseUpload,
  uploadAccessData,
  uploadCloseData,
} from 'utils/uploadData';
import DataStorage from 'utils/dataStore';

export default {
  components: {
    FixedHeader,
    // GoodsDemo,
    RefundPicker,
    PreBuyButton,
    Pay,
    GoodsTags,
    ToUseButton,
  },
  data() {
    const { id: nowOrderId, goBack } = this.$route.query;
    return {
      nowPageObj: this,
      nowOrderId,
      REFUND_OPTION,
      isShowReasonPicker: false,
      targetUrl: goBack === 'my' ? '/my' : '', // 返回的时候去个人中心或者上一页
      nowDetail: {
        city: {},
        province: {},
        district: {},
        virtual_info: {
          virtual_start: '',
          virtual_end: '',
        },
      },
      hasAnyAction: false, // 是否有操作
      hasRouteChange: false,
      isShowPay: false,
      oldOrderId: null,
      payCode: '',
      paying: false,
    };
  },
  watch: {
    hasAnyAction: {
      handler(val) {
        DataStorage.setPageVisitiLog(val);
      },
      immediate: true,
    },
  },
  computed: {
    isPreSell() {
      const {
        nowDetail: { pre_sell_info },
      } = this;
      return !!pre_sell_info;
    },
    nowStatus() {
      return this.nowDetail.order_status_code;
    },
    depositTitle() {
      const {
        nowDetail: { is_pay_deposit },
      } = this;
      return is_pay_deposit ? '已付定金' : '付定金';
    },
    retainageTitle() {
      const {
        nowDetail: {
          is_pay_final,
          pre_sell_info: { retainage_start },
        },
      } = this;
      const time = dateFormater(retainage_start, 'MM-dd hh:mm');
      return is_pay_final ? '已付尾款' : `${time} 开始支付尾款`;
    },
    totalPriceTitle() {
      const {
        showRefundStatus,
        nowDetail: { is_pay },
      } = this;
      if (showRefundStatus) {
        return '退款总金额';
      }
      return is_pay ? '实付金额' : '应付金额';
    },
    totalPrice() {
      const {
        nowDetail: {
          order_amount, order_status, paid_money, integral,
        },
      } = this;
      if (integral) {
        if (Number(order_amount)) {
          return `¥${order_amount}+${integral}积分`;
        }
        return `${integral}积分`;
      }
      return order_status === 3
        ? parseFloat(order_amount) + parseFloat(paid_money)
        : order_amount;
    },
    showPreSellTip() {
      const { isPreSell, nowStatus } = this;
      return isPreSell && (isWaitPay(nowStatus) || isPayDeposit(nowStatus));
    },
    showPreSellBuy() {
      return this.nowStatus === 'WAIT_PAY_RETAINAGE';
    },
    canRefund() {
      const {
        nowDetail: { can_refund },
      } = this;
      return can_refund === 1;
    },
    showCancelRefund() {
      const {
        nowDetail: { order_status, pay_status, refund_status },
      } = this;
      return order_status === 3 && refund_status === 1 && pay_status >= 1;
    },
    showEditAddr() {
      const {
        nowDetail: { order_status },
      } = this;
      return order_status === 0;
    },
    showPayWay() {
      const {
        nowDetail: { pay_code },
      } = this;
      if (pay_code === 'wechart') {
        return '微信支付';
      } else if (pay_code === 'alipay') {
        return '支付宝支付';
      } else if (pay_code === 'wallet') {
        return '芒果钱包';
      }
      return '';
    },
    /* 待发货的订单取消后 订单状态变成已取消 这时要显示退款状态 */
    showRefundStatus() {
      const {
        nowStatus,
        nowDetail: { pay_status },
      } = this;
      if (nowStatus === 'CANCEL') {
        if (pay_status === 1) {
          return '处理中';
        } else if (pay_status === 3) {
          return '退款成功';
        } else if (pay_status === 4) {
          return '拒绝退款';
        }
        return '';
      } else if (nowStatus === 'REFUND') {
        return '拒绝退款';
      } else if (nowStatus === 'CANCEL_REFUND') {
        return '退款成功';
      } else if (nowStatus === 'CANCELLED') {
        if (pay_status === 2) {
          return '退款成功';
        } else if (pay_status === 3) {
          return '退款成功';
        }
      }
      return '';
    },
    showRefundRemark() {
      const {
        nowDetail: { admin_note },
        showRefundStatus,
      } = this;
      return showRefundStatus && admin_note;
    },
    show_address() {
      const {
        nowDetail: { prom_type },
      } = this;
      if (prom_type === 5) {
        return false;
      }
      return true;
    },
    show_goodsDemo() {
      const {
        nowDetail: { prom_type },
      } = this;
      if (prom_type === 5 || prom_type === 7) {
        return false;
      }
      return true;
    },
    showUseTime() {
      if (this.nowDetail.virtual_info) {
        const {
          nowDetail: {
            is_virtual,
            virtual_info: { virtual_start, virtual_end },
          },
        } = this;
        if (is_virtual && virtual_start && virtual_end) {
          return true;
        }
      }
      return false;
    },
    useGotoLink() {
      if (!this.nowDetail.virtual_info) {
        return false;
      }
      const {
        nowDetail: {
          virtual_info: { virtual_url },
        },
      } = this;
      if (virtual_url) {
        return virtual_url;
      }
      return false;
    },
  },
  created() {
    this.fetchDetail();
  },
  mounted() {
    initCloseUpload();
    const clipboard = new ClipboardJS('.copy_button');
    const that = this;
    clipboard.on('success', (e) => {
      that.$toast({
        message: '复制成功',
        duration: 1000,
      });
      that.hasAnyAction = true;
      e.clearSelection();
    });
  },
  beforeRouteLeave(to, from, next) {
    if (!this.hasRouteChange) {
      uploadCloseData();
    }
    next();
  },
  methods: {
    getOrderStatusTitle,
    showAddress,
    getActualPrice(price) {
      const {
        nowDetail: { goods_list },
      } = this;
      if (!goods_list.length) {
        return '';
      }
      return (goods_list[0].goods_num * Number(price)).toFixed(2);
    },
    async gotoPay() {
      this.hasAnyAction = true;
      const {
        nowDetail: { order_id: orderId },
      } = this;
      if (!this.paying) {
        this.paying = true;
        if (this.showPreSellBuy) {
          try {
            const newId = await orderApi.submitRetainageOrder({ orderId });
            this.nowOrderId = newId;
            this.oldOrderId = orderId;
            this.payCode = ''; // 新的订单 支付方式不限定
          } catch (error) {
            this.$toast(`支付调起失败：${error.message}`);
            return;
          }
          this.refreshOrder = true;
        }
        this.isShowPay = true;
      } else {
        this.$toast('请勿重复下单');
      }
    },
    async uploadClose(callback) {
      this.hasRouteChange = true; // 支付成功回来之后 路由会变化 但是支付的时候已经上报了  所以设置为true 不再上报
      await uploadCloseData();
      if (typeof callback === 'function') {
        callback();
      }
    },
    showPrice(
      { pre_sell_info: info },
      { goods_price, exchange_integral, exchange_price },
    ) {
      if (exchange_integral) {
        if (Number(exchange_price)) {
          return `¥${exchange_price}+${exchange_integral}积分`;
        }
        return `${exchange_integral}积分`;
      }
      return `¥${this.isPreSell ? info.sale_price : goods_price}`;
    },
    showRefundButton(item) {
      const { nowStatus } = this;
      return (
        (nowStatus === 'WAITCCOMMENT' || nowStatus === 'FINISH') &&
          !item.is_apply_refund &&
          !item.exchange_integral
      );
    },
    async submitReason({ title }) {
      const { nowOrderId } = this;
      this.isShowReasonPicker = false;
      this.$loading.open();
      try {
        await orderApi.refundOrder({ order_id: nowOrderId, userNote: title });
        this.$toast({ message: '提交成功', duration: 500 });
        window.location.reload();
      } catch (error) {
        this.$toast({ message: `提交失败：${error.message}`, duration: 500 });
      }
      this.$loading.close();
    },
    gotoDetail(id) {
      beforeRouteChange(
        { path: '/goods/detail', query: { id, showBack: 1 } },
        this,
      );
    },
    gotoRefund({
      rec_id,
      order_id,
      goods_id,
      goods_num,
      refund_amount,
      goods_image,
      goods_name,
      spec_key_name,
    }) {
      const {
        isPreSell,
        nowDetail: { order_sn, refund_amount: orderRefund },
      } = this;
      const refund_price = isPreSell ? orderRefund : refund_amount;
      beforeRouteChange(
        {
          path: '/refund/apply',
          query: {
            rec_id,
            order_id,
            order_sn,
            goods_id,
            goods_num,
            goods_image,
            goods_name,
            spec_key_name,
            refund_price,
          },
        },
        this,
      );
    },
    async fetchDetail() {
      const { nowOrderId } = this;
      if (!nowOrderId) {
        return;
      }
      const data = await orderApi.getOrderDetail({ id: nowOrderId });
      if (data) {
        this.nowDetail = data;
        const { goods_list } = data;
        uploadAccessData({
          orderid: nowOrderId,
          ...getGoodsSizeNum(goods_list),
        });
      }
    },
    async cancelRefundApply() {
      const { nowOrderId } = this;
      this.$loading.open();
      try {
        await orderApi.cancelRefundOrder({ order_id: nowOrderId });
        this.$toast({ message: '提交成功', duration: 500 });
        window.location.reload();
      } catch (error) {
        this.$toast({ message: `提交失败：${error.message}`, duration: 1500 });
      }
      this.$loading.close();
    },
    gotoEdit() {
      if (this.showEditAddr) {
        beforeRouteChange(
          {
            path: '/address/manage',
            query: { from: 'detail', orderId: this.nowOrderId },
          },
          this,
        );
      }
    },
    getUseTime() {
      const {
        nowDetail: {
          virtual_info: { virtual_start, virtual_end },
        },
      } = this;
      if (virtual_start && virtual_end) {
        return `${virtual_start} - ${virtual_end}`;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.crowdfunding-order-detail {
  height: 100%;
  box-sizing: border-box;

  &__main {
    height: 100%;
  }

  &__top {
    background: #fff;
    border-radius: 20px;
    padding: 30px;
    margin: 24px 0 20px 0;
    font-size: 28px;
    color: #000000;
    display: flex;

    div:first-child {
      width: 22px;
      margin-right: 20px;
    }

    div:last-child {
      flex: 1;

      p:first-child {
        margin-bottom: 12px;
      }

      p:last-child {
        i {
          float: right;
        }
      }

      span {
        margin-right: 20px;
      }
    }
  }

  &__content {
    background: #fff;
    border-radius: 20px;
    padding: 20px 30px 0 30px;
    margin: 20px 0;

    &-status {
      font-size: 24px;
      color: #ff4c00;
      height: 33px;
    }

    &-goods-wrap {
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);
      padding-bottom: 20px;
    }

    &-goods {
      display: flex;
      padding-bottom: 20px;
      padding-top: 20px;

      &-img {
        margin-right: 40px;
        width: 150px;

        img {
          max-width: 150px;
          height: 150px;
        }
      }

      &-sku {
        flex: 1;

        p {
          margin-top: 8px;
          font-size: 26px;
          color: #000000;
          display: flex;
          word-break: break-all;
        }

        p:nth-of-type(1),
        p:nth-of-type(2) {
          span:first-child {
            flex: 1;
          }

          span:last-child {
            margin-left: 60px;
          }
        }

        p:nth-of-type(2) {
          font-size: 24px;
          color: #999999;
        }

        p:nth-of-type(3) {
          margin-top: 26px;
          justify-content: flex-end;

          span {
            width: 144px;
            height: 48px;
            line-height: 48px;
            border: 1px solid #9b9b9b;
            border-radius: 27px;
            text-align: center;
          }
        }
      }
    }

    &-button {
      display: flex;
      justify-content: flex-end;

      span {
        font-size: 24px;
        width: 100px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #9b9b9b;
        border-radius: 20px;
        text-align: center;
      }
    }

    &-cancel_button {
      display: flex;
      justify-content: flex-end;

      span {
        font-size: 24px;
        width: 150px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #9b9b9b;
        border-radius: 20px;
        text-align: center;
      }
    }

    &-item {
      display: flex;
      height: 55px;
      align-items: center;
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);
      font-size: 22px;
      justify-content: space-between;

      span:first-child {
        color: #4a4a4a;
      }
    }

    &-item:last-child {
      border: none;

      span:first-child {
        color: #000;
      }

      span:last-child {
        color: #ff5f00;
      }
    }
  }

  &__presell {
    &-item {
      font-size: 22px;
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);

      p {
        margin: 20px 0;
        display: flex;
        justify-content: space-between;
      }
    }

    &-logo {
      display: flex;
      margin: 10px 0;
    }

    &-desc {
      font-size: 22px;
      color: #f47125;
    }

    &-buy {
      text-align: right;
    }
  }

  &__bottom {
    padding: 14px 30px;
    background: #fff;
    border-radius: 20px;
    font-size: 22px;
    margin-bottom: 30px;
    color: #000000;

    section {
      height: 45px;
      line-height: 45px;
      display: flex;
      word-break: break-all;
    }

    &-title {
      width: 145px;
      flex-shrink: 0;
    }

    &-modal {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 145px;
      right: 96px;
      background: #fff;
      z-index: 1000;
    }

    section:first-child {
      position: relative;

      input {
        flex: 1;
      }

      button:last-child {
        width: 96px;
        height: 40px;
        line-height: 40px;
        font-size: 20px;
        border: 1px solid #9b9b9b;
        border-radius: 18px;
        text-align: center;
      }
    }

    section:last-child {
      height: auto;
    }
  }
}
</style>
